<template>
  <div>
    <div class="row">
      <div class="col-sm-9">
        <h3 class="text-left">Emails</h3>
      </div>
      <div class="col-sm-3 text-right">
        <button class="e-btn e-btn-green e-text-white pr-3 mt-2" data-toggle="modal" data-target="#NewEmail">
          <font-awesome-icon icon="plus-square" style="width: 25px"/>
          <small class="font-weight-bold">
            ADD NEW EMAIL
          </small>
        </button>
      </div>
    </div>

    <div class="row">
      <nav aria-label="...">
        <ul class="pagination text-smallest mb-2 pb-0">
          <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
            <button class="page-link" @click="setPage(1)">First</button>
          </li>

          <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
            <button class="page-link" @click="setPage(page)">{{ page }}</button>
          </li>

          <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
            <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
          </li>
        </ul>
      </nav>
    </div>

    <table class="table table-sm table-bordered small">
      <thead>
      <tr>
        <th class="text-center" scope="col" style="width: 100px">#</th>
        <th class="text-center" scope="col">EMAIL</th>
        <th class="text-center" scope="col" style="width: 300px">ACTION</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="loading">
        <td colspan="100%">
          <loading></loading>
        </td>
      </tr>
      <template v-else>
        <tr class="list-data" v-for="(email, index) in emailLists" @dblclick="viewEmailDetails(email)">
          <th class="m-0 p-0 align-middle text-center" scope="row">{{ index + pagination.from }}</th>
          <td class="m-0 p-0 align-middle text-center">{{ email.email_address }}</td>
          <td class="m-0 p-0 align-middle text-center">
            <div class="dropdown dropleft my-1">
              <button
                id="actionDropdown"
                aria-expanded="false"
                aria-haspopup="true"
                class="btn btn-sm btn-secondary force-white-all"
                data-toggle="dropdown"
              >
                <font-awesome-icon icon="cogs"/>
              </button>
              <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                <button class="dropdown-item text-secondary font-weight-bolder"
                        @click="viewEmailDetails(email)"
                >
                  <font-awesome-icon icon="eye"/>
                  View
                </button>
                <button class="dropdown-item text-secondary font-weight-bolder"
                        @click="viewEmailDetailsInNewTab(email)"
                >
                  <font-awesome-icon icon="share"/>
                  View on New Tab
                </button>
                <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                        @click="deleteEmail(email.id)"
                        v-if=""
                >
                  <font-awesome-icon icon="trash" class="force-danger-all"/>
                  Delete
                </button>
              </div>
            </div>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <new-email/>
  </div>

</template>


<script>

import { PaginationMixin } from "@/mixins/PaginationMixin";
import EmailDetails from "@/components/settings/emails/EmailDetails.vue";
import {mapActions, mapGetters} from "vuex";
import loading from "@/components/elements/AppLoading.vue";
import NewEmail from "@/components/settings/emails/NewEmail.vue";
import {AlertService} from "@/services/AlertService";
export default {
  name : 'SettingEmails',
  data() {
    return {
      loading : false,
      active : 1,
      page : 1,
    }
  },
  components: {NewEmail, loading, EmailDetails},
  mixins : [
    PaginationMixin
  ],
  methods: {
    ...mapActions('EmailModule', [
      'getEmailLists',
      'deleteEmailById',
    ]),
    ...mapActions('ModuleTableModule', [
      'getModuleKeys'
    ]),
    setPage(page) {
      this.pagination.currentPage = page;
      this.page = page
      this.requestEmails();
    },
    async requestEmails() {
      this.loading = true;
      await this.getEmailLists({
        active : this.active,
        page   : this.page
      });
      this.loading = false;
    },
    getLandingModule(modules) {
      const moduleCodes = modules.map(item => item.code);
      let landingModule = '';

      for (let counter = 0; counter < this.moduleKeys.length; counter++) {
        if (moduleCodes.includes(this.moduleKeys[counter].code)) {
          landingModule = this.moduleKeys[counter].code;
          break;
        }
      }
      return landingModule;
    },
    async viewEmailDetails(email) {
      const landingModule = this.getLandingModule(email.modules);
      await this.$router.push(
        {
          name: 'EmailDetails',
          params: {
            email_id: email.id,
            active_module : landingModule
          },
        },

      ).catch(() => {})
    },
    async viewEmailDetailsInNewTab(email) {
      const landingModule = this.getLandingModule(email.modules);
      const route= this.$router.resolve(
        {
          name: 'EmailDetails',
          params: {
            email_id: email.id,
            active_module : landingModule
          },
        },
      )
      window.open(route.href,'_blank')
    },
    async deleteEmail(emailId) {
      if (await AlertService.confirmDeleteAlert('DELETION OF EMAIL', 'Are you sure you want to delete this email?', 'DELETE')) {
        swal.fire({
          title:'ENTER YOUR PASSWORD',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off'
          },
          confirmButtonText:'PROCEED DELETION',
          cancelButtonText: 'CANCEL',
          showCancelButton:true,
          allowOutsideClick:false,
          allowEscapeKey:false,
          allowEnterKey:false,
          confirmButtonColor:'#dc3545',
          showLoaderOnConfirm:true,
          preConfirm:async (inputValue)=> {
            let response = await this.deleteEmailById({
              email_id : emailId,
              password : inputValue
            });

            if (response.result === false) {
              AlertService.errorAlert(response.message, 'DELETE EMAIL');
              return;
            }
            AlertService.successAlert('Email Deleted Successfully','DELETE EMAIL');
            this.page = 1;
            await this.requestEmails();
          }
        })
      }
    }
  },
  async created() {
    await this.requestEmails();
    await this.getModuleKeys();
  },
  computed: {
    ...mapGetters('EmailModule', [
      'emailLists'
    ]),
    ...mapGetters('ModuleTableModule', [
      'moduleKeys'
    ]),
  }
}
</script>

<style scoped>

</style>
